import axios from 'axios'
import { jwtDecode } from 'jwt-decode'

import { API_ENDPOINTS } from '@/constants/apiEndpoints'
import { decodeUserEmail, decodeUserId, decodeUserName } from '@/utils/userUtils'

// withCredentials lets the browser store the HttpOnly cookie that authorizes /media/ files.
const MEDIA_COOKIE_REQUEST_CONFIG = { withCredentials: true }

function buildAuthData(response) {
    const token = response?.data?.token

    const decoded = token ? jwtDecode(token) || {} : {}
    const userId = token ? decodeUserId(token) : null
    const userEmail = token ? decodeUserEmail(token) : null
    const userName = decodeUserName(JSON.stringify(decoded))

    return { token, userId, userEmail, userName, response }
}

// Perform login a request and return structured auth data.
export async function login(credentials) {
    const response = await axios.post(API_ENDPOINTS.USERS.TOKEN, credentials, MEDIA_COOKIE_REQUEST_CONFIG)
    return buildAuthData(response)
}

export async function loginWithRogerCard(cardNumber) {
    const response = await axios.post(API_ENDPOINTS.USERS.ROGER_CARD_TOKEN, { cardNumber }, MEDIA_COOKIE_REQUEST_CONFIG)
    return buildAuthData(response)
}

// Refresh the JWT token and return the new token.
export async function refreshToken(currentToken) {
    const response = await axios.post(API_ENDPOINTS.USERS.TOKEN_REFRESH, { token: currentToken }, MEDIA_COOKIE_REQUEST_CONFIG)
    const newToken = response?.data?.token
    return { token: newToken, response }
}

// Remove the /media/ cookie - it is HttpOnly, so only the backend can delete it.
export async function logout() {
    return axios.post(API_ENDPOINTS.USERS.LOGOUT, null, MEDIA_COOKIE_REQUEST_CONFIG)
}
